export default __webpack_public_path__ + "static/media/social-distancing.513ffe77.png";